import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  ObraDetailsState,
  ObraDetailsAction,
  ObraDetailsReducer,
} from './obra-details-reducer';

const initialState: ObraDetailsState = {
  obraDetails: null,
  loading: false,
  error: null,
};

const ObraDetailsStateContext = createContext<ObraDetailsState | undefined>(undefined);
const ObraDetailsDispatchContext = createContext<React.Dispatch<ObraDetailsAction> | undefined>(undefined);

interface ObraDetailsProviderProps {
  children: ReactNode;
}

export const ObraDetailsProvider: React.FC<ObraDetailsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(ObraDetailsReducer, initialState);

  return (
    <ObraDetailsStateContext.Provider value={state}>
      <ObraDetailsDispatchContext.Provider value={dispatch}>
        {children}
      </ObraDetailsDispatchContext.Provider>
    </ObraDetailsStateContext.Provider>
  );
};

export const useObraDetailsState = (): ObraDetailsState => {
  const context = useContext(ObraDetailsStateContext);
  if (context === undefined) {
    throw new Error('useObraDetailsState must be used within a ObraDetailsProvider');
  }
  return context;
};

export const useObraDetailsDispatch = (): React.Dispatch<ObraDetailsAction> => {
  const context = useContext(ObraDetailsDispatchContext);
  if (context === undefined) {
    throw new Error('useObraDetailsDispatch must be used within a ObraDetailsProvider');
  }
  return context;
};
